(() => {
  angular
    .module('app.campaign')
    .controller('IntegratedCampaignsDeleteModalController', IntegratedCampaignsDeleteModal);

  IntegratedCampaignsDeleteModal.$inject = [
    'CampaignService',
    'provider',
    'account',
    'accounts',
    'close'
  ];

  function IntegratedCampaignsDeleteModal(
    CampaignService,
    provider,
    account,
    accounts,
    close,
  ) {
    var vm = this;
    vm.accounts = accounts;
    vm.campaigns = [],
    vm.campaignsLoaded = true;

    vm.confirmDelete = function() {
      close(true, 500);
    }

    /* Campaigns */
    if (provider) {
      vm.provider = provider.providerName;
      vm.account = account.accountName;
      vm.campaignsLoaded = false;
      console.log(account);

      const sortPredicate = 'creation-date';
      const isSortOrderAscending = false;
      const filters = {
        fusionAccount: account.accountId,
        provider: provider.provider,
        type: 'integrated'
      };

      CampaignService.getPaginated(0, 100, sortPredicate, isSortOrderAscending, filters)
        .then(({ data }) => {
          vm.campaigns = data || [];
        })
        .finally(() => {
          vm.campaignsLoaded = true;
        });
    }
  }
})();
